import { NgModule } from '@angular/core';

import { WindowResizeService } from './window-resize.service';

@NgModule({
  providers: [WindowResizeService],
})
export class WindowResizeModule {}
